<p class="text-muted">Hello, 
  <b>
    {{!!userDetails && userDetails.first_name}} 
    {{!!userDetails && userDetails.last_name}}
  </b>
From your My Account Dashboard you have the ability to view a snapshot of your recent account activity and update your account information. Select a link below to view or edit information.</p>

<div fxLayout="row wrap" class="flex-wrapper">
    <div fxFlex="33.3" fxFlex.sm="50" fxFlex.xs="100" class="col">
        <mat-card class="p-0">
          <mat-card-header class="p-1 account-card-title" fxLayoutAlign="space-between center">
              <mat-card-title class="m-0"><h3>Account Information</h3></mat-card-title>
              <a mat-icon-button routerLink="/account/information"><mat-icon class="text-muted">edit</mat-icon></a>
          </mat-card-header>
          <div class="divider"></div>
          <mat-card-content class="p-2 text-muted account-card-content">
              <div *ngIf="!!userDetails; else noDataFound">
                <p>{{userDetails.first_name}} {{userDetails.last_name}}</p>
                <p>{{userDetails.email_id}}</p>
                <p><a routerLink="/account/information" class="primary-text">Change password</a></p>
              </div>
              <ng-template #noDataFound>
                <p>No Information Found!</p>
              </ng-template>
          </mat-card-content>
        </mat-card>
    </div>
    <div fxFlex="33.3" fxFlex.sm="50" fxFlex.xs="100" class="col">
        <mat-card class="p-0">
          <mat-card-header class="p-1 account-card-title" fxLayoutAlign="space-between center">
              <mat-card-title class="m-0"><h3>Addresses</h3></mat-card-title>
              <a mat-icon-button routerLink="/account/addresses"><mat-icon class="text-muted">edit</mat-icon></a>
          </mat-card-header>
          <div class="divider"></div>
          <mat-card-content class="p-2 text-muted account-card-content">
            <div *ngIf="!!userDetails; else noDataFound">
              <p *ngIf="!!userDetails.address">{{userDetails.address}},</p>
              <p *ngIf="!!userDetails.city">{{userDetails.city}},</p>
              <p *ngIf="!!userDetails.state">{{userDetails.state}},</p>
              <p *ngIf="!!userDetails.county">{{userDetails.county}},</p>
              <p *ngIf="!!userDetails.zipcode">{{userDetails.zipcode}}</p>
              <p><a routerLink="/account/addresses" class="primary-text">Change Address</a></p>
            </div>
            <ng-template #noDataFound>
              <p>No Address Found!</p>
            </ng-template>
          </mat-card-content>
        </mat-card>
    </div>
    <div fxFlex="33.3" fxFlex.sm="100" fxFlex.xs="100" class="col">
        <mat-card class="p-0">
          <mat-card-header class="p-1 account-card-title" fxLayoutAlign="space-between center">
              <mat-card-title class="m-0"><h3>Default CreditCard</h3></mat-card-title>
              <a mat-icon-button routerLink="/account/payment"><mat-icon class="text-muted">edit</mat-icon></a>
            </mat-card-header>
          <div class="divider"></div>
          <mat-card-content class="p-2 text-muted account-card-content">
            <div *ngIf="!!creditCard; else noDataFound">
              <p>{{creditCard.holder_name}}</p>
              <p>Card Type {{creditCard.cardType}}</p>
              <p>Card Last 4 digits {{creditCard.last4}}</p>
              <p>Expires on {{creditCard.expirydate}}</p>
            </div>
            <ng-template #noDataFound>
              <p>No Default CreditCard Found!</p>
            </ng-template>
          </mat-card-content>
        </mat-card>
    </div>
</div>